import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map, take } from 'rxjs/operators';
import {UserDetailService} from '@services';
import {MY_TRACEY_EDIT} from "../app-routing.module";
import {UserDetail} from "@model";

export function canActivateMyTraceyProfileGuard(): CanActivateFn {
    return () => {
        const router = inject(Router);
        const userDetailService = inject(UserDetailService);

        return userDetailService.fetchCurrentUserDetails().pipe(
            take(1),
            map((user: UserDetail | undefined) => {
                if (user && user?.id) {
                    return true;
                }
                router.navigate([MY_TRACEY_EDIT]);
                return false;
            })
        );
    };
}
